export default "__VITE_ASSET__Ba493zIW__"